// extracted by mini-css-extract-plugin
export default {"divInput":"style_divInput__3iF5Z"};